
import Toast from 'vux/src/components/toast/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import loading from '@/components/public-components/loading/index.vue'
import mapUtil from '@/javascript/mapUtil'
import util from '@/javascript/util'
import EsQuery from '@/javascript/esQuery'
import mapList from '@/components/lyx-components/mapList/index.vue'
import goBack from '@/components/public-components/goBack/index.vue'

export default {
components: {
Tab,
TabItem,
loading,
Toast,
mapList,
goBack
},
data () {
return {
isTop: 1,
showMapList: false,
iscon: false,
isUp: false, // 上滑显示
BFchange: true,
BFbtn: false,
minHeight: 0,
toastShow: false,
toastText: '您当前位置不在海晏县,将为您切换至海晏县',
pumpScience: false,
pumpJj: false,
sliBtn: false,
goldShow: false,
play: false,
auit: true,
topAudio: false,
audioShow: true,
onePlay: '',
scienceId: this.$route.params.id,
oneAudioData: '',
toiletBlock: false,
currentTab: 0,
curIndex:this.$route.params.tabIndex,
cur: 0,
bomData: [{
name: '景点',
jpname: 'JD',
icon: require('../../../assets/public-img/jd.png'),
selectIcon: require('../../../assets/public-img/jd-select.png'),
show: true,
data: [],
type: '127001'
},{
name: '出入口',
jpname: 'CRK',
icon: require('../../../assets/public-img/crk.png'),
selectIcon: require('../../../assets/public-img/crk-select.png'),
show: true,
data: [],
type: '127005'
},{
name: '游客中心',
jpname: 'YKZX',
icon: require('../../../assets/public-img/ykzx.png'),
selectIcon: require('../../../assets/public-img/ykzx-select.png'),
show: true,
data: [],
type: '127004'
},{
name: '停车场',
jpname: 'TCC',
icon: require('../../../assets/public-img/tcc.png'),
selectIcon: require('../../../assets/public-img/tcc-select.png'),
show: true,
data: [],
type: '127003'
}, {
name: '厕所',
jpname: 'CS',
icon: require('../../../assets/public-img/cs.png'),
selectIcon: require('../../../assets/public-img/cs-select.png'),
show: true,
data: [],
type: '127002'
}, {
name: '住宿',
jpname: 'ZS',
icon: require('../../../assets/public-img/zs.png'),
selectIcon: require('../../../assets/public-img/zs-select.png'),
show: true,
data: [],
type: '127026'
},{
name: '餐饮',
jpname: 'CY',
icon: require('../../../assets/public-img/cy.png'),
selectIcon: require('../../../assets/public-img/cy-select.png'),
show: true,
data: [],
type: '127007'
},{
name: '购物',
jpname: 'GW',
icon: require('../../../assets/public-img/gw.png'),
selectIcon: require('../../../assets/public-img/gw-select.png'),
show: true,
data: [],
type: '127006'
}],
nearType: ['商场', '加油站', '充电桩', '超市', '商业街'],
markers: [],    //地图点
audioPlayTime: '',
audioAllTime: '',
markerData: {},
widthTime: 0,
scienceData: {},
auidoName: '',
mapMarkerLink: '',
map: '',
videoPumpData: {},
playStates: 0,
mapLayers: {},
mapZoom: 0,
kindDatas: [],
kind: '',
datas: [],
nearPageNo: 1,
pageSize: 10,
positionData: '',
locateData: {
lng: '',
lat: '',
},
audioData: '',
markerArray: [],
centermarker: [],
curTime: '',
lineWidth: 0,
playStatus: false,
startY: 0,
defaultHeight: 0,
listTop: 0,
moveEndY: 0,
defaultTop: 0,
maxTop: 0,
}
},

created(){
let ua = navigator.userAgent.toLowerCase();
if (ua.match(/MicroMessenger/i) == "micromessenger") {

wx.miniProgram.getEnv((res) => {
if (res.miniprogram) {
this.wxLink = true
} else {
console.log("不在小程序里");
}
})
} else {
this.wxLink = false
console.log('不在微信里');
}
},

mounted () {
const _this = this;

document.title = this.PAGE_TITLE + '导游导览'
this.defaultHeight = this.$refs.defaultBox.offsetHeight;
this.listTop = document.documentElement.clientHeight - 2 * this.$refs.defaultBox.offsetHeight;
this.defaultTop = this.listTop;


let audio = document.getElementById('oneAudio')
audio.addEventListener('play',function(){
});
audio.addEventListener('pause',function(){
});
/**
* 微信签名分享
*/
if (util.isWeiXin()) {
console.log('111111...');
const shareData = typeof (shareData) === 'undefined' ? {
title: _this.PAGE_TITLE + '-智能导览',
desc: '醉美海晏~',
imgUrl: window.location.origin + '/static/zg-img/banner_img.png',
link: window.location.href
} : shareData;
this.$http.get('/api/wtcp-support/weixin/createJsapiSignature?url=' + encodeURIComponent(window.location.href) + '&appId=' + this.WX_APPID).then((response) => {
util.initWxConfig(response.data.data, shareData)
})
}

this.minHeight = document.documentElement.clientHeight;


this.locationWay().then(() => {
this.createMapNo()
})
},

methods: {
goDetail() {
switch(this.kind) {
case 'JD':
this.$router.push({path: '/scenicView/' + this.markerData.id})
break
case 'MS':
this.$router.push({path: '/businessView/' + this.XXCJ_TYPE_CODE.CY + '/' + this.markerData.id})
break
case 'ZS':
this.$router.push({path: '/hotelDetails/' + this.markerData.id})
break
}
},

listStart(e) {





this.startY = e.changedTouches[0].pageY;


},
toggle(flag) {
this.isTop = !this.isTop
let maxTop = document.documentElement.clientHeight - this.$refs.slideList.offsetHeight
this.listTop = flag ? maxTop : this.defaultTop

},
listMove(e) {
const _this = this;



let maxTop = document.documentElement.clientHeight - _this.$refs.slideList.offsetHeight;

let eleHeight = document.getElementById('slideList').style.top
eleHeight = parseInt(eleHeight.slice(0,eleHeight.length-1))
if (_this.defaultTop > eleHeight) {
this.isTop = 0
} else {
this.isTop = 1
}
_this.maxTop = maxTop
if(_this.listTop<maxTop) {
_this.listTop = maxTop
}
if(_this.listTop>_this.defaultTop) {
_this.listTop = _this.defaultTop
}
e.preventDefault();
let moveEndY = e.targetTouches[0].pageY
if (_this.moveEndY!=0) {
moveEndY -= _this.moveEndY
} else {
moveEndY = 0
}
if((maxTop<=_this.listTop) && (_this.listTop<=_this.defaultTop)) {
_this.listTop += moveEndY
_this.moveEndY = e.targetTouches[0].pageY
if(_this.listTop<maxTop) {
_this.listTop = maxTop
return
}
if(_this.listTop>_this.defaultTop) {
_this.listTop = _this.defaultTop
return
}
}

},
listEnd(e) {




this.moveEndY = 0

},

updateProgress(e) {
let progress = document.getElementById('audioProgress')
let audio = document.getElementById('oneAudio')
let width = (e.offsetX / progress.offsetWidth).toFixed(2)
audio.currentTime = audio.duration * width
},

audioProgress() {
let audio = document.getElementById('oneAudio')


let value = audio.currentTime/audio.duration*100
this.curTime = this.transTime(audio.currentTime);
this.lineWidth = value.toFixed(2)
},

transTime(value) {
let time = "";
let h = parseInt(value / 3600);
value %= 3600;
let m = parseInt(value / 60);
let s = parseInt(value % 60);
if (h > 0) {
time = this.formatTime(h + ":" + m + ":" + s);
} else {
time = this.formatTime(m + ":" + s);
}
return time;
},

formatTime(value) {
let time = "";
let s = value.split(':');
let i = 0;
for (i; i < s.length - 1; i++) {
time += s[i].length == 1 ? ("0" + s[i]) : s[i];
time += ":";
}
time += s[i].length == 1 ? ("0" + s[i]) : s[i];
return time;
},

audioPlay (item) {
const _this = this
if(!item.data.audios[0]){
_this.oneAudioData = ''
_this.audioData = ''
return
}





_this.playStatus = !_this.playStatus
let audio = document.getElementById('oneAudio')
if(_this.playStatus) {
_this.$set(_this, 'oneAudioData', _this.PIC_BASE_URL + item.data.audios[0])
_this.audioData = item.data.audios[0]
setTimeout(function () {
audio.play()
}, 0)
} else {
audio.pause()
}
},
pumpJjClick(item) {
this.markerData = item
this.pumpScience = true
if(!this.playStatus) {
this.audioPlay(item)
}
},
changeBtn () {
this.BFchange = !this.BFchange

const _this = this
if (this.BFchange) {

setTimeout(function () {

_this.$refs.oneAudio.play()
_this.watchMusicTime()
}, 200)
} else {
this.$refs.oneAudio.pause()
}


},
closeBtn () {
this.BFbtn = false
this.BFchange = true
this.oneAudioData = ''
},
locationWay: function () {
/**
* 定位
*/
return new Promise((resolve, reject) => {
mapUtil.locate((data) => {
this.macLnt = data.position.lng
this.macLat = data.position.lat
this.locationResult(data)
this.positionData = data
resolve()
}, (data) => {
if (data == undefined) {
this.$notify({
title: '警告',
message: '定位失败，请开启定位权限',
type: 'warning'
});






} else {
this.macLnt = data.position.lng
this.macLat = data.position.lat
this.locationResult(data)
this.positionData = data
}
resolve()
})
})
},

locationResult: function (val) {
const adcode = val.addressComponent.adcode
this.nowLoction = val.location
if (adcode == "711500") {
this.adcodeExist = true
this.locateData.lng = '100.9961'
this.locateData.lat = '36.1332'
}

if (this.adcodeExist) {
this.center = [this.nowLoction.lng, this.nowLoction.lat]
this.zoom = 13
this.locateData.lng = '100.9961'
this.locateData.lat = '36.1332'
} else {

this.center = [101.009202,36.121257]
this.zoom = 10
this.locateData.lng = this.macLnt
this.locateData.lat = this.macLat
}
},
setCenter() {
if (this.kindDatas.length > 0) {
const Point = new AMap.LngLat(this.kindDatas[0].longitude, this.kindDatas[0].latitude)
this.map.setCenter(Point)
}
},
onItemClick: function (index, drawFlag, ui) {
if (ui) {
this.isTop = 1
}
return new Promise((resolve, reject) => {
this.currentTab = index
this.map.clearMap();
this.kindDatas = []


this.cur = index
if (this.cur == 0) {
this.isUp = false
} else {
this.isUp = true
}
this.listTop = this.defaultTop
this.sliBtn = true
this.pumpScience = false

this.datas = [];
this.kind = this.bomData[index].jpname;
this.toiletBlock = false;
let typeKind = [];
let typeName = this.bomData[index].type;

const querystring = require('querystring')
const serviceEsQuery = new EsQuery()
serviceEsQuery
.addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, serviceEsQuery.and, false)
.addStartWith("type", typeName, serviceEsQuery.and, false)
.addStartWith("principalId", this.scienceId, serviceEsQuery.and, false)
.addPage(0, 500)

const lineEsJsonQuery = JSON.stringify(serviceEsQuery.getArray())
this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
'indexName': this.INDEX_NAME_TYPE.poi,
'esJsonQuery': lineEsJsonQuery
})).then((response) => {
this.kindList = response.data.data

if (!response.data.data || response.data.data.length == 0) {
this.kindDatas = [];
} else {
this.kindDatas = this.kindList.map((item, index) => {
for (let i = 0; i < this.bomData.length; i++) {
if (this.bomData[i].type == item._source.type) {
return {
id: item._source.id,
longitude: item._source.longitude,
latitude: item._source.latitude,
lonlatLine: item._source.longitude + ',' + item._source.latitude,
pointId: item._source.id,
title: item._source.title,
address: item._source.address,
interval: mapUtil.getDistance(this.macLnt, this.macLat, item._source.longitude, item._source.latitude),
img: item._source.images[0],
mapicon: this.bomData[i].selectIcon,
selectIcon: this.bomData[i].selectIcon,
type: this.bomData[i].type,
data: item._source,
}
}

}

})

this.kindDatas = this.kindDatas.sort(this.getRankList("interval"))


let lon = 0;
let lat = 0;
this.kindDatas.forEach(item=>{
lon += parseFloat(item.lonlatLine.split(',')[0])
lat += parseFloat(item.lonlatLine.split(',')[1])
})
this.center = [(lon/this.kindDatas.length).toFixed(3),(lat/this.kindDatas.length).toFixed(3)]
}
}).then(() => {


this.$set(this, 'markers', this.kindDatas)



if (drawFlag) {
this.marPoint(this.map, this.markers)
this.setCenter()
this.currentTab = index
}
resolve()
})
})
},
createMap(center, mapLayers) {
const _this = this

_this.mapZoom = mapLayers.map.defaultLevel
_this.map = new AMap.Map('guide_map', {
resizeEnable: true,
zoom: mapLayers.map.defaultLevel,
zooms: [mapLayers.map.minLevel, mapLayers.map.maxLevel - 1],
center: center
});



AMap.plugin([
'AMap.ToolBar',
], function () {
_this.map.addControl(new AMap.ToolBar({
liteStyle: true,
locate: true,
position: 'LT'
}));
});




_this.$nextTick(function () {
_this.initMapLayer(_this.map, mapLayers)
})

},
createMapNo () {
const _this = this
_this.map = new AMap.Map('guide_map', {
resizeEnable: true,
zoom: 17,
center: [101.026748,36.872229]
});


_this.map.clearMap();


AMap.plugin([
'AMap.ToolBar',
], function () {
_this.map.addControl(new AMap.ToolBar({
liteStyle: true,
locate: false,
position: 'LT'
}));
});

/* 定位到当前位置 */
AMap.event.addDomListener(document.getElementById('pantoBtn1'), 'click', function () {
_this.toiletBlock = false

_this.map.panTo([_this.macLnt, _this.macLat]);


});

this.onItemClickLoop(0)


},
onItemClickLoop(i) {
if (i >= this.bomData.length) {
for (let i=0; i<this.bomData.length; i++) {
if (this.bomData[i].show) {
this.currentTab = i
this.kindDatas = this.bomData[i].data
this.onItemClick(i, true)
break
}
}
return
}
this.onItemClick(i).then(() => {
if (this.kindDatas.length == 0) {
this.bomData[i].show = false
}
this.bomData[i].data = this.kindDatas
this.onItemClickLoop(++i)
})
},

nearBySearch (typeName, index) {

const _this = this

const keywords = typeName

AMap.service(["AMap.PlaceSearch"], function () {

const placeSearch = new AMap.PlaceSearch({

pageSize: _this.pageSize, // 单页显示结果条数
pageIndex: _this.nearPageNo, // 页码
city: _this.positionData.addressComponent.citycode, // 兴趣点城市
citylimit: true,  //是否强制限制在设置的城市内搜索
autoFitView: true 
})

const cpoint = [_this.locateData.lng, _this.locateData.lat] 


placeSearch.searchNearBy(keywords, cpoint, 3000, function (status, result) {
if (result.poiList && result.poiList.count > 0) {
const { poiList: { pois: data } } = result
_this.nearList = data.map(item => {
for (let i = 0; i < _this.bomData.length; i++) {
if (item.type.includes(_this.bomData[i].type)) {
return {
longitude: item.location.lng,
latitude: item.location.lat,
lonlatLine: item.location.lng + ',' + item.location.lat,
pointId: item.id,
title: item.name,
address: item.address,
interval: mapUtil.getDistance(_this.macLnt, _this.macLat, item.location.lng, item.location.lat),
mapicon: _this.bomData[i].selectIcon,
type: _this.bomData[i].type,
data: item,
}
}

}
})
_this.kindDatas = _this.nearList.filter(item => item != undefined)
}

let lon = 0;
let lat = 0;
_this.kindDatas.forEach(item=>{
lon += parseFloat(item.lonlatLine.split(',')[0])
lat += parseFloat(item.lonlatLine.split(',')[1])
})
_this.center = [(lon/_this.kindDatas.length).toFixed(3),(lat/_this.kindDatas.length).toFixed(3)]

if (typeName == '超市') {
_this.map.setZoom(17)
} else if (typeName == '医院') {
_this.map.setZoom(13)
} else {
_this.map.setZoom(14)
}
_this.$set(_this, 'markers', _this.kindDatas)
_this.marPoint(_this.map, _this.markers)
this.setCenter()

})
})
},

getRankList (prop) { //升序
return function (obj1, obj2) {
let val1 = obj1[prop].slice(0, -2);
let val2 = obj2[prop].slice(0, -2);
if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
val1 = Number(val1);
val2 = Number(val2);
}
if (val1 < val2) {
return -1;
} else if (val1 > val2) {
return 1;
} else {
return 0;
}
}
},


closePump () {
const _this = this
_this.pumpScience = false


_this.play = false
if (!_this.$refs.oneAudio.ended) {
_this.topAudio = true
}
if (_this.$refs.oneAudio.paused) {
_this.topAudio = false
}
if (_this.$refs.oneAudio.muted) {
_this.topAudio = false
_this.$refs.oneAudio.pause()
}
},




closeGold () {
this.goldShow = false
this.play = true
},
slideBtn () {
this.sliBtn = !this.sliBtn
},














playAuit () {
const _this = this
if (_this.$refs.oneAudio.muted) {
_this.auit = true
_this.$refs.oneAudio.muted = false
} else {
_this.auit = false
_this.$refs.oneAudio.muted = true;
}
},

formatSeconds (value) {
let theTime = parseInt(value);
let theTime1 = 0;
let theTime2 = 0;
if (theTime > 60) {
theTime1 = parseInt(theTime / 60);
theTime = parseInt(theTime % 60);
if (theTime1 > 60) {
theTime2 = parseInt(theTime1 / 60);
theTime1 = parseInt(theTime1 % 60);
}
}
let result = "" + parseInt(theTime);
if (10 > theTime > 0) {
result = "0" + parseInt(theTime);
} else {
result = "" + parseInt(theTime);
}

if (10 > theTime1 > 0) {
result = "0" + parseInt(theTime1) + ":" + result; 
} else {
result = "" + parseInt(theTime1) + ":" + result; 
}
if (theTime2 > 0) {
result = "" + parseInt(theTime2) + ":" + result; 
}
return result;
},

watchMusicTime () {
let _this = this;
let musicDom = _this.$refs.oneAudio; 

musicDom.addEventListener("timeupdate", function () {//监听音频播放的实时时间事件
let timeDisplay;
_this.audioAllTime = _this.formatSeconds(_this.$refs.oneAudio.duration)

timeDisplay = Math.floor(musicDom.currentTime); 

let minute = timeDisplay / 60;
let minutes = parseInt(minute);
if (minutes < 10) {
minutes = "0" + minutes;
}

let second = timeDisplay % 60;
let seconds = Math.round(second);
if (seconds < 10) {
seconds = "0" + seconds;
}
_this.audioPlayTime = minutes + ":" + seconds;

let width = (musicDom.currentTime) * 100 / (musicDom.duration) + "%"
_this.widthTime = width

if (musicDom.ended) {
_this.play = true
_this.topAudio = false
_this.playStates = 1
}
}, false);
},

closeTopAudio () {
this.topAudio = false
this.$refs.oneAudio.pause()
},

marPoint (map, data) {
const _this = this

for (let i = 0; i < data.length; i++) {
let marker = new AMap.Marker({
position: [data[i].longitude, data[i].latitude],
map: map,
content: '<div class="map-icon">' +
'<p> ' + data[i].title + '</p>' +

'<img src="/marker.png"></div>'
});

marker.content = _this.markers[i];
marker.on('click', function (e) {

_this.play = false
_this.topAudio = false
_this.$set(_this, 'markerData', data[i])
_this.mapMarkerLink = data[i].pointId
if (data[i].data.audio) {
_this.audioShow = true
_this.$set(_this, 'oneAudioData', _this.PIC_BASE_URL + data[i].audio)
_this.auidoName = ' “' + data[i].title + '” '
setTimeout(function () {
_this.$refs.oneAudio.play()
if (_this.$refs.oneAudio.muted) {
_this.auit = true
_this.$refs.oneAudio.muted = false
}

_this.watchMusicTime()
}, 200)
} else {
_this.audioShow = false
_this.oneAudioData = ''
}
setTimeout(function () {
_this.pumpScience = true
}, 10)

});
}


},


initMapLayer(map, mapLayers) {
const _this = this
if (!mapLayers.layers) return;

let aMapTileLayer = new AMap.TileLayer({
zIndex: 2,
getTileUrl(x, y, z) {
let tileItem = ""
let url = ""
mapLayers.layers.forEach(item => {
if (item.zoom === z) {
tileItem = item
}
})

if (typeof (tileItem) != "undefined" && x >= tileItem.xmintile && x <= tileItem.xmaxtile && y >= tileItem.ymintile && y <= tileItem.ymaxtile) {

url = _this.PIC_BASE_URL + "/wtcp-material/siteguide/" + mapLayers.map.siteId + "/tiles/" + z + "/tile_" + x + "_" + y + ".png";
} else {

url = _this.PIC_BASE_URL + "/wtcp-map/tiles/map_blank.png";
}
return url;
}
});

aMapTileLayer.setMap(map);
},


upDown () {
this.iscon = !this.iscon
},


showMapListone (item) {
if(!(this.macLnt&&this.macLat)) {
alert('加载中...')
return
}
this.markerData = item
this.showMapList = true
},

showDetail(item) {
this.markerData = item
this.pumpScience = true
const Point = new AMap.LngLat(item.longitude, item.latitude)
this.map.setCenter(Point)
}

}
}
